import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { HttpParams } from '@angular/common/http';
import { CurrencyPipe } from '@angular/common';
import { JwtHelperService } from "@auth0/angular-jwt";
import { ConsumersService } from '../../consumers.service';
import { FeeConfigService } from '../../fee-config.service';
import { ActivatedRoute } from '@angular/router';
const helper = new JwtHelperService();
@Component({
  selector: 'app-config-history',
  templateUrl: './config-history.component.html',
  styleUrls: ['./config-history.component.scss'],
  providers: [CurrencyPipe]
})
export class ConfigHistoryComponent extends FeaturesBaseComponent implements OnInit {
  searchValue: any;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  rowData: any;
  columnDefs: any;
  id: any;



  constructor(private activeRoute: ActivatedRoute,private consumerService: ConsumersService, private feeConfigService: FeeConfigService) {
    super();
    const self = this;
    this.columnDefs = [
      { field: 'currPaymentType', headerName: 'Current Payment Type', width: 230, sort: "desc" },
      { field: 'prevPaymentType', headerName: 'Previous Payment Type', width: 230  },
      { field: 'currFeeType', headerName: 'Current Fee Type', width: 230  },
      { field: 'prevFeeType', headerName: 'Previous Fee Type', width: 230  },
      { field: 'currFeeValue', headerName: 'Current Fee Value', width: 230  },
      { field: 'prevFeeValue', headerName: 'Previous Fee Value', width: 230  },
      { field: 'currValidityStartDttm', headerName: 'Current Start Date', width: 230  },
      { field: 'prevValidityStartDttm', headerName: 'Previous Start Date', width: 230  },
      { field: 'currValidityEndDttm', headerName: 'Current End Date', width: 230  },
      { field: 'prevValidityEndDttm', headerName: 'Previous End Date', width: 230  },
      { field: 'createdDttm', headerName: 'Created Date & Time', width: 230  },
      { field: 'createdBy', headerName: 'Created By', width: 230  },
      { field: 'updatedBy', headerName: 'Updated By', width: 230  },
    
      // {
      //   field: 'visitedDate', headerName: 'Visited Date', width: 180, cellRenderer: (data) => {
      //     return formatDate(data.value, 'MM/dd/yyyy', 'en')
      //   }
      // },
    ]

  }
  setGrid(resData) {
    const self = this; self
    this.rowData = resData;

  }
  exportData() {
    this.gridApi.exportDataAsCsv();
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.id = this.activeRoute.snapshot.paramMap.get('id');
    this.feeConfigService.allConfigHistory(this.id).subscribe({
      next: (res: any) => {
        if (res["httpcode"] == 200) {
          this.setGrid(res.data);
        }
      },
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
}
